// FlagContext.js
import { urlEndPoint } from "helpers/GeneralHelper";
import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

export const FlagContext = createContext();

export const FlagProvider = ({ children }) => {
  const storedLang = localStorage.getItem("country_code")? JSON.parse(localStorage.getItem("country_code")) : "GB"; 

  const [selectedLang, setSelectedLang] = useState(storedLang);
  const navigate = useNavigate();

  const updateLang = (lang) => {
    localStorage.setItem("country_code", JSON.stringify(lang));
    setSelectedLang(lang);
    // navigate(`${urlEndPoint.homePageUrl}`);
    window.location.reload()
  };

  return (
    <FlagContext.Provider value={{ selectedLang, updateLang }}>
      {children}
    </FlagContext.Provider>
  );
};
